import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {designSystemToken} from '@lightricks/react-design-system';
import {DURATION_MINUTES_SECONDS_MILLISECONDS_FORMAT} from '@/config/timeFormats';

dayjs.extend(customParseFormat);

export const calculatePhraseScore = (difference: number) => {
  const absoluteDifference = Math.abs(difference);
  const gradeMap: Record<number, {score: string; color: string}> = {
    0: {score: 'perfect!', color: designSystemToken('semantic.fg.success')},
    1: {score: 'good!', color: designSystemToken('semantic.fg.success')},
    2: {score: 'a bit too', color: designSystemToken('semantic.fg.warning')},
  };
  const defaultScore = {
    score: 'too',
    color: designSystemToken('semantic.fg.danger'),
  };
  const {score, color} = gradeMap[absoluteDifference] || defaultScore;
  let phrase = score;
  if (absoluteDifference > 1) {
    phrase = `${score} ${difference > 0 ? 'long' : 'short'}`;
  }
  return {phrase, color};
};

export const calculateLength = (text: string) => {
  return text
    .trim()
    .split(' ')
    .filter((word) => word.length > 0).length;
};

export const formatTime = (time: unknown): string => {
  if (typeof time !== 'string') {
    console.warn('Invalid time input: expected a string.', time);
    return '0:00.000'; // or return null, empty string, or throw, depending on your needs
  }

  const parsed = dayjs(time.replace(',', '.'), 'HH:mm:ss.SSS');

  if (!parsed.isValid()) {
    console.warn('Invalid time format:', time);
    return '0:00.000';
  }

  return parsed.format(DURATION_MINUTES_SECONDS_MILLISECONDS_FORMAT);
};
